
import { defer as observableDefer, concat as observableConcat, Observable, Subscription, defer } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";

import { LoaderService } from "../../services/loader.service";
import { ObservableLoader } from "../../models/loader.model";
import { finalize, retry } from "rxjs/operators";

import { StaticLoaderComponent } from './static-loader.component';

@Component({
    selector: "loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    imports: [StaticLoaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoaderComponent implements OnInit {
  public text?: string | null;
  public showLoader: boolean = false;

  constructor(public loaderService: LoaderService, private cdr: ChangeDetectorRef) {
    this.loaderService.register(this);
  }

  public ngOnInit() {
    this.updateLoader();
  }

  private updateLoader(): void {
    this.loaderService.getLoader().subscribe(result => {
      this.showLoader = result.showLoader;
      this.text = result.text;
      this.cdr.markForCheck();
    });
  }

  public load(observables: ObservableLoader[]): Observable<any> {
    return this.runObservables(observables);
  }

  public runObservables(observables: ObservableLoader[]): Observable<any> {
    return defer(() => {
      this.showLoader = true;
      this.cdr.markForCheck();

      return observableConcat(
        ...(observables.map(x => observableDefer(() => {
          this.text = x.text;
          this.cdr.markForCheck();
          return x.observable
        })))
      ).pipe(
        retry(5),
        finalize(() => {
          this.text = null;
          this.showLoader = false;
          this.cdr.markForCheck();
        })
      );
    });
  }
}
